import request, { get, post } from '@/utils/request';
export function login(data) {
  return request({
    url: '/api/login/pcLogin',
    method: 'post',
    data: data
  });
}

//获取用户信息
export function getUserDetail() {
  return request({
    url: '/system/getUserDetail',
    method: 'post'
  });
}
//注册(激活设备)
export function register(data) {
  return request({
    url: '/api/login/register',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}

/** 获取登录日志 */
export function getLoginLogs(data) {
  return get("/system/getLoginLogList", data);
}

/** 获取验证码 */
export function getVerify(data) {
  return post('/api/captcha/getcaptcha', data);
}
export var getAreas = function getAreas() {
  return get("/api/area/areaList");
};